import _classCallCheck from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _assertThisInitialized from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _inherits from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
import _slicedToArray from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NAMESPACE = 'ionphaser';
var queuePending = false;
var win = typeof window !== 'undefined' ? window : {};
var doc = win.document || {
  head: {}
};
var plt = {
  $flags$: 0,
  $resourcesUrl$: '',
  jmp: function jmp(h) {
    return h();
  },
  raf: function raf(h) {
    return requestAnimationFrame(h);
  },
  ael: function ael(el, eventName, listener, opts) {
    return el.addEventListener(eventName, listener, opts);
  },
  rel: function rel(el, eventName, listener, opts) {
    return el.removeEventListener(eventName, listener, opts);
  },
  ce: function ce(eventName, opts) {
    return new CustomEvent(eventName, opts);
  }
};

var promiseResolve = function promiseResolve(v) {
  return Promise.resolve(v);
};

var supportsConstructibleStylesheets = /*@__PURE__*/function () {
  try {
    new CSSStyleSheet();
    return typeof new CSSStyleSheet().replace === 'function';
  } catch (e) {}

  return false;
}();

var HYDRATED_CSS = '{visibility:hidden}.hydrated{visibility:inherit}';

var createTime = function createTime(fnName) {
  var tagName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  {
    return function () {
      return;
    };
  }
};

var uniqueTime = function uniqueTime(key, measureText) {
  {
    return function () {
      return;
    };
  }
};

var rootAppliedStyles = new WeakMap();

var registerStyle = function registerStyle(scopeId, cssText, allowCS) {
  var style = styles.get(scopeId);

  if (supportsConstructibleStylesheets && allowCS) {
    style = style || new CSSStyleSheet();
    style.replace(cssText);
  } else {
    style = cssText;
  }

  styles.set(scopeId, style);
};

var addStyle = function addStyle(styleContainerNode, cmpMeta, mode, hostElm) {
  var scopeId = getScopeId(cmpMeta);
  var style = styles.get(scopeId); // if an element is NOT connected then getRootNode() will return the wrong root node
  // so the fallback is to always use the document for the root node in those cases

  styleContainerNode = styleContainerNode.nodeType === 11
  /* DocumentFragment */
  ? styleContainerNode : doc;

  if (style) {
    if (typeof style === 'string') {
      styleContainerNode = styleContainerNode.head || styleContainerNode;
      var appliedStyles = rootAppliedStyles.get(styleContainerNode);
      var styleElm;

      if (!appliedStyles) {
        rootAppliedStyles.set(styleContainerNode, appliedStyles = new Set());
      }

      if (!appliedStyles.has(scopeId)) {
        {
          {
            styleElm = doc.createElement('style');
            styleElm.innerHTML = style;
          }
          styleContainerNode.insertBefore(styleElm, styleContainerNode.querySelector('link'));
        }

        if (appliedStyles) {
          appliedStyles.add(scopeId);
        }
      }
    } else if (!styleContainerNode.adoptedStyleSheets.includes(style)) {
      styleContainerNode.adoptedStyleSheets = [].concat(_toConsumableArray(styleContainerNode.adoptedStyleSheets), [style]);
    }
  }

  return scopeId;
};

var attachStyles = function attachStyles(hostRef) {
  var cmpMeta = hostRef.$cmpMeta$;
  var elm = hostRef.$hostElement$;
  var endAttachStyles = createTime('attachStyles', cmpMeta.$tagName$);
  var scopeId = addStyle(elm.getRootNode(), cmpMeta);
  endAttachStyles();
};

var getScopeId = function getScopeId(cmp, mode) {
  return 'sc-' + cmp.$tagName$;
};

var isComplexType = function isComplexType(o) {
  // https://jsperf.com/typeof-fn-object/5
  o = typeof o;
  return o === 'object' || o === 'function';
};

var getElement = function getElement(ref) {
  return getHostRef(ref).$hostElement$;
};

var emitEvent = function emitEvent(elm, name, opts) {
  var ev = plt.ce(name, opts);
  elm.dispatchEvent(ev);
  return ev;
};

var attachToAncestor = function attachToAncestor(hostRef, ancestorComponent) {
  if (ancestorComponent && !hostRef.$onRenderResolve$ && ancestorComponent['s-p']) {
    ancestorComponent['s-p'].push(new Promise(function (r) {
      return hostRef.$onRenderResolve$ = r;
    }));
  }
};

var scheduleUpdate = function scheduleUpdate(hostRef, isInitialLoad) {
  {
    hostRef.$flags$ |= 16
    /* isQueuedForUpdate */
    ;
  }

  if (hostRef.$flags$ & 4
  /* isWaitingForChildren */
  ) {
    hostRef.$flags$ |= 512
    /* needsRerender */
    ;
    return;
  }

  attachToAncestor(hostRef, hostRef.$ancestorComponent$); // there is no ancestor component or the ancestor component
  // has already fired off its lifecycle update then
  // fire off the initial update

  var dispatch = function dispatch() {
    return dispatchHooks(hostRef, isInitialLoad);
  };

  return writeTask(dispatch);
};

var dispatchHooks = function dispatchHooks(hostRef, isInitialLoad) {
  var endSchedule = createTime('scheduleUpdate', hostRef.$cmpMeta$.$tagName$);
  var instance = hostRef.$lazyInstance$;
  var promise;
  endSchedule();
  return then(promise, function () {
    return updateComponent(hostRef, instance, isInitialLoad);
  });
};

var updateComponent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(hostRef, instance, isInitialLoad) {
    var elm, endUpdate, rc, endRender, childrenPromises, postUpdate;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // updateComponent
            elm = hostRef.$hostElement$;
            endUpdate = createTime('update', hostRef.$cmpMeta$.$tagName$);
            rc = elm['s-rc'];

            if (isInitialLoad) {
              // DOM WRITE!
              attachStyles(hostRef);
            }

            endRender = createTime('render', hostRef.$cmpMeta$.$tagName$);
            callRender(hostRef, instance);

            if (rc) {
              // ok, so turns out there are some child host elements
              // waiting on this parent element to load
              // let's fire off all update callbacks waiting
              rc.map(function (cb) {
                return cb();
              });
              elm['s-rc'] = undefined;
            }

            endRender();
            endUpdate();
            childrenPromises = elm['s-p'];

            postUpdate = function postUpdate() {
              return postUpdateComponent(hostRef);
            };

            if (childrenPromises.length === 0) {
              postUpdate();
            } else {
              Promise.all(childrenPromises).then(postUpdate);
              hostRef.$flags$ |= 4
              /* isWaitingForChildren */
              ;
              childrenPromises.length = 0;
            }

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateComponent(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var callRender = function callRender(hostRef, instance, elm) {
  try {
    instance = instance.render && instance.render();
    {
      hostRef.$flags$ &= ~16
      /* isQueuedForUpdate */
      ;
    }
    {
      hostRef.$flags$ |= 2
      /* hasRendered */
      ;
    }
  } catch (e) {
    consoleError(e, hostRef.$hostElement$);
  }

  return null;
};

var postUpdateComponent = function postUpdateComponent(hostRef) {
  var tagName = hostRef.$cmpMeta$.$tagName$;
  var elm = hostRef.$hostElement$;
  var endPostUpdate = createTime('postUpdate', tagName);
  var ancestorComponent = hostRef.$ancestorComponent$;

  if (!(hostRef.$flags$ & 64
  /* hasLoadedComponent */
  )) {
    hostRef.$flags$ |= 64
    /* hasLoadedComponent */
    ;
    {
      // DOM WRITE!
      addHydratedFlag(elm);
    }
    endPostUpdate();
    {
      hostRef.$onReadyResolve$(elm);

      if (!ancestorComponent) {
        appDidLoad();
      }
    }
  } else {
    endPostUpdate();
  }

  {
    hostRef.$onInstanceResolve$(elm);
  } // load events fire from bottom to top
  // the deepest elements load first then bubbles up

  {
    if (hostRef.$onRenderResolve$) {
      hostRef.$onRenderResolve$();
      hostRef.$onRenderResolve$ = undefined;
    }

    if (hostRef.$flags$ & 512
    /* needsRerender */
    ) {
      nextTick(function () {
        return scheduleUpdate(hostRef, false);
      });
    }

    hostRef.$flags$ &= ~(4
    /* isWaitingForChildren */
    | 512
    /* needsRerender */
    );
  } // ( •_•)
  // ( •_•)>⌐■-■
  // (⌐■_■)
};

var appDidLoad = function appDidLoad(who) {
  // on appload
  // we have finish the first big initial render
  {
    addHydratedFlag(doc.documentElement);
  }
  nextTick(function () {
    return emitEvent(win, 'appload', {
      detail: {
        namespace: NAMESPACE
      }
    });
  });
};

var safeCall = function safeCall(instance, method, arg) {
  if (instance && instance[method]) {
    try {
      return instance[method](arg);
    } catch (e) {
      consoleError(e);
    }
  }

  return undefined;
};

var then = function then(promise, thenFn) {
  return promise && promise.then ? promise.then(thenFn) : thenFn();
};

var addHydratedFlag = function addHydratedFlag(elm) {
  return elm.classList.add('hydrated');
};

var parsePropertyValue = function parsePropertyValue(propValue, propType) {
  // ensure this value is of the correct prop type
  if (propValue != null && !isComplexType(propValue)) {
    if (propType & 4
    /* Boolean */
    ) {
      // per the HTML spec, any string value means it is a boolean true value
      // but we'll cheat here and say that the string "false" is the boolean false
      return propValue === 'false' ? false : propValue === '' || !!propValue;
    } // redundant return here for better minification


    return propValue;
  } // not sure exactly what type we want
  // so no need to change to a different type


  return propValue;
};

var getValue = function getValue(ref, propName) {
  return getHostRef(ref).$instanceValues$.get(propName);
};

var setValue = function setValue(ref, propName, newVal, cmpMeta) {
  // check our new property value against our internal value
  var hostRef = getHostRef(ref);
  var elm = hostRef.$hostElement$;
  var oldVal = hostRef.$instanceValues$.get(propName);
  var flags = hostRef.$flags$;
  var instance = hostRef.$lazyInstance$;
  newVal = parsePropertyValue(newVal, cmpMeta.$members$[propName][0]);

  if ((!(flags & 8
  /* isConstructingInstance */
  ) || oldVal === undefined) && newVal !== oldVal) {
    // gadzooks! the property's value has changed!!
    // set our new value!
    hostRef.$instanceValues$.set(propName, newVal);

    if (instance) {
      // get an array of method names of watch functions to call
      if (cmpMeta.$watchers$ && flags & 128
      /* isWatchReady */
      ) {
        var watchMethods = cmpMeta.$watchers$[propName];

        if (watchMethods) {
          // this instance is watching for when this property changed
          watchMethods.map(function (watchMethodName) {
            try {
              // fire off each of the watch methods that are watching this property
              instance[watchMethodName](newVal, oldVal, propName);
            } catch (e) {
              consoleError(e, elm);
            }
          });
        }
      }

      if ((flags & (2
      /* hasRendered */
      | 16
      /* isQueuedForUpdate */
      )) === 2
      /* hasRendered */
      ) {
        // looks like this value actually changed, so we've got work to do!
        // but only if we've already rendered, otherwise just chill out
        // queue that we need to do an update, but don't worry about queuing
        // up millions cuz this function ensures it only runs once
        scheduleUpdate(hostRef, false);
      }
    }
  }
};

var proxyComponent = function proxyComponent(Cstr, cmpMeta, flags) {
  if (cmpMeta.$members$) {
    if (Cstr.watchers) {
      cmpMeta.$watchers$ = Cstr.watchers;
    } // It's better to have a const than two Object.entries()


    var members = Object.entries(cmpMeta.$members$);
    var prototype = Cstr.prototype;
    members.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          memberName = _ref3[0],
          _ref3$ = _slicedToArray(_ref3[1], 1),
          memberFlags = _ref3$[0];

      if (memberFlags & 31
      /* Prop */
      || flags & 2
      /* proxyState */
      && memberFlags & 32
      /* State */
      ) {
        // proxyComponent - prop
        Object.defineProperty(prototype, memberName, {
          get: function get() {
            // proxyComponent, get value
            return getValue(this, memberName);
          },
          set: function set(newValue) {
            // proxyComponent, set value
            setValue(this, memberName, newValue, cmpMeta);
          },
          configurable: true,
          enumerable: true
        });
      } else if (flags & 1
      /* isElementConstructor */
      && memberFlags & 64
      /* Method */
      ) {
        // proxyComponent - method
        Object.defineProperty(prototype, memberName, {
          value: function value() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            var ref = getHostRef(this);
            return ref.$onInstancePromise$.then(function () {
              var _ref$$lazyInstance$;

              return (_ref$$lazyInstance$ = ref.$lazyInstance$)[memberName].apply(_ref$$lazyInstance$, args);
            });
          }
        });
      }
    });

    if (flags & 1
    /* isElementConstructor */
    ) {
      var attrNameToPropName = new Map();

      prototype.attributeChangedCallback = function (attrName, _oldValue, newValue) {
        var _this = this;

        plt.jmp(function () {
          var propName = attrNameToPropName.get(attrName);
          _this[propName] = newValue === null && typeof _this[propName] === 'boolean' ? false : newValue;
        });
      }; // create an array of attributes to observe
      // and also create a map of html attribute name to js property name


      Cstr.observedAttributes = members.filter(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            _ = _ref5[0],
            m = _ref5[1];

        return m[0] & 15;
      }
      /* HasAttribute */
      ) // filter to only keep props that should match attributes
      .map(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            propName = _ref7[0],
            m = _ref7[1];

        var attrName = m[1] || propName;
        attrNameToPropName.set(attrName, propName);
        return attrName;
      });
    }
  }

  return Cstr;
};

var initializeComponent = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(elm, hostRef, cmpMeta, hmrVersionId, Cstr) {
    var endLoad, endNewInstance, style, scopeId, endRegisterStyles, ancestorComponent, schedule;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!((hostRef.$flags$ & 32
            /* hasInitializedComponent */
            ) === 0)) {
              _context2.next = 18;
              break;
            }

            // we haven't initialized this element yet
            hostRef.$flags$ |= 32
            /* hasInitializedComponent */
            ; // lazy loaded components
            // request the component's implementation to be
            // wired up with the host element

            Cstr = loadModule(cmpMeta);

            if (!Cstr.then) {
              _context2.next = 9;
              break;
            }

            // Await creates a micro-task avoid if possible
            endLoad = uniqueTime();
            _context2.next = 7;
            return Cstr;

          case 7:
            Cstr = _context2.sent;
            endLoad();

          case 9:
            if (!Cstr.isProxied) {
              // we'eve never proxied this Constructor before
              // let's add the getters/setters to its prototype before
              // the first time we create an instance of the implementation
              {
                cmpMeta.$watchers$ = Cstr.watchers;
              }
              proxyComponent(Cstr, cmpMeta, 2
              /* proxyState */
              );
              Cstr.isProxied = true;
            }

            endNewInstance = createTime('createInstance', cmpMeta.$tagName$); // ok, time to construct the instance
            // but let's keep track of when we start and stop
            // so that the getters/setters don't incorrectly step on data

            hostRef.$flags$ |= 8
            /* isConstructingInstance */
            ;

            // construct the lazy-loaded component implementation
            // passing the hostRef is very important during
            // construction in order to directly wire together the
            // host element and the lazy-loaded instance
            try {
              new Cstr(hostRef);
            } catch (e) {
              consoleError(e);
            }

            hostRef.$flags$ &= ~8
            /* isConstructingInstance */
            ;
            hostRef.$flags$ |= 128
            /* isWatchReady */
            ;
            endNewInstance();
            fireConnectedCallback(hostRef.$lazyInstance$);

            if (Cstr.style) {
              // this component has styles but we haven't registered them yet
              style = Cstr.style;
              scopeId = getScopeId(cmpMeta);

              if (!styles.has(scopeId)) {
                endRegisterStyles = createTime('registerStyles', cmpMeta.$tagName$);
                registerStyle(scopeId, style, !!(cmpMeta.$flags$ & 1
                /* shadowDomEncapsulation */
                ));
                endRegisterStyles();
              }
            }

          case 18:
            // we've successfully created a lazy instance
            ancestorComponent = hostRef.$ancestorComponent$;

            schedule = function schedule() {
              return scheduleUpdate(hostRef, true);
            };

            if (ancestorComponent && ancestorComponent['s-rc']) {
              // this is the intial load and this component it has an ancestor component
              // but the ancestor component has NOT fired its will update lifecycle yet
              // so let's just cool our jets and wait for the ancestor to continue first
              // this will get fired off when the ancestor component
              // finally gets around to rendering its lazy self
              // fire off the initial update
              ancestorComponent['s-rc'].push(schedule);
            } else {
              schedule();
            }

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function initializeComponent(_x4, _x5, _x6, _x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}();

var fireConnectedCallback = function fireConnectedCallback(instance) {
  {
    safeCall(instance, 'connectedCallback');
  }
};

var _connectedCallback = function connectedCallback(elm) {
  if ((plt.$flags$ & 1
  /* isTmpDisconnected */
  ) === 0) {
    var hostRef = getHostRef(elm);
    var cmpMeta = hostRef.$cmpMeta$;
    var endConnected = createTime('connectedCallback', cmpMeta.$tagName$);

    if (!(hostRef.$flags$ & 1
    /* hasConnected */
    )) {
      // first time this component has connected
      hostRef.$flags$ |= 1
      /* hasConnected */
      ;
      {
        // find the first ancestor component (if there is one) and register
        // this component as one of the actively loading child components for its ancestor
        var ancestorComponent = elm;

        while (ancestorComponent = ancestorComponent.parentNode || ancestorComponent.host) {
          // climb up the ancestors looking for the first
          // component that hasn't finished its lifecycle update yet
          if (ancestorComponent['s-p']) {
            // we found this components first ancestor component
            // keep a reference to this component's ancestor component
            attachToAncestor(hostRef, hostRef.$ancestorComponent$ = ancestorComponent);
            break;
          }
        }
      } // Lazy properties
      // https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties

      if (cmpMeta.$members$) {
        Object.entries(cmpMeta.$members$).map(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 2),
              memberName = _ref10[0],
              _ref10$ = _slicedToArray(_ref10[1], 1),
              memberFlags = _ref10$[0];

          if (memberFlags & 31
          /* Prop */
          && elm.hasOwnProperty(memberName)) {
            var value = elm[memberName];
            delete elm[memberName];
            elm[memberName] = value;
          }
        });
      }

      {
        initializeComponent(elm, hostRef, cmpMeta);
      }
    } else {
      // fire off connectedCallback() on component instance
      fireConnectedCallback(hostRef.$lazyInstance$);
    }

    endConnected();
  }
};

var _disconnectedCallback = function disconnectedCallback(elm) {
  if ((plt.$flags$ & 1
  /* isTmpDisconnected */
  ) === 0) {
    var hostRef = getHostRef(elm);
    var instance = hostRef.$lazyInstance$;
    {
      safeCall(instance, 'disconnectedCallback');
    }
  }
};

var bootstrapLazy = function bootstrapLazy(lazyBundles) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var endBootstrap = createTime();
  var cmpTags = [];
  var exclude = options.exclude || [];
  var customElements = win.customElements;
  var head = doc.head;
  var metaCharset = /*@__PURE__*/head.querySelector('meta[charset]');
  var visibilityStyle = /*@__PURE__*/doc.createElement('style');
  var deferredConnectedCallbacks = [];
  var appLoadFallback;
  var isBootstrapping = true;
  Object.assign(plt, options);
  plt.$resourcesUrl$ = new URL(options.resourcesUrl || './', doc.baseURI).href;
  lazyBundles.map(function (lazyBundle) {
    return lazyBundle[1].map(function (compactMeta) {
      var cmpMeta = {
        $flags$: compactMeta[0],
        $tagName$: compactMeta[1],
        $members$: compactMeta[2],
        $listeners$: compactMeta[3]
      };
      {
        cmpMeta.$members$ = compactMeta[2];
      }
      {
        cmpMeta.$watchers$ = {};
      }
      var tagName = cmpMeta.$tagName$;

      var HostElement = /*#__PURE__*/function (_HTMLElement) {
        _inherits(HostElement, _HTMLElement);

        var _super = _createSuper(HostElement);

        // StencilLazyHost
        function HostElement(self) {
          var _this2;

          _classCallCheck(this, HostElement);

          // @ts-ignore
          _this2 = _super.call(this, self);
          self = _assertThisInitialized(_this2);
          registerHost(self, cmpMeta);
          return _this2;
        }

        _createClass(HostElement, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            var _this3 = this;

            if (appLoadFallback) {
              clearTimeout(appLoadFallback);
              appLoadFallback = null;
            }

            if (isBootstrapping) {
              // connectedCallback will be processed once all components have been registered
              deferredConnectedCallbacks.push(this);
            } else {
              plt.jmp(function () {
                return _connectedCallback(_this3);
              });
            }
          }
        }, {
          key: "disconnectedCallback",
          value: function disconnectedCallback() {
            var _this4 = this;

            plt.jmp(function () {
              return _disconnectedCallback(_this4);
            });
          }
        }, {
          key: "componentOnReady",
          value: function componentOnReady() {
            return getHostRef(this).$onReadyPromise$;
          }
        }]);

        return HostElement;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

      cmpMeta.$lazyBundleId$ = lazyBundle[0];

      if (!exclude.includes(tagName) && !customElements.get(tagName)) {
        cmpTags.push(tagName);
        customElements.define(tagName, proxyComponent(HostElement, cmpMeta, 1
        /* isElementConstructor */
        ));
      }
    });
  });
  {
    visibilityStyle.innerHTML = cmpTags + HYDRATED_CSS;
    visibilityStyle.setAttribute('data-styles', '');
    head.insertBefore(visibilityStyle, metaCharset ? metaCharset.nextSibling : head.firstChild);
  } // Process deferred connectedCallbacks now all components have been registered

  isBootstrapping = false;

  if (deferredConnectedCallbacks.length) {
    deferredConnectedCallbacks.map(function (host) {
      return host.connectedCallback();
    });
  } else {
    {
      plt.jmp(function () {
        return appLoadFallback = setTimeout(appDidLoad, 30);
      });
    }
  } // Fallback appLoad event


  endBootstrap();
};

var hostRefs = new WeakMap();

var getHostRef = function getHostRef(ref) {
  return hostRefs.get(ref);
};

var registerInstance = function registerInstance(lazyInstance, hostRef) {
  return hostRefs.set(hostRef.$lazyInstance$ = lazyInstance, hostRef);
};

var registerHost = function registerHost(elm, cmpMeta) {
  var hostRef = {
    $flags$: 0,
    $hostElement$: elm,
    $cmpMeta$: cmpMeta,
    $instanceValues$: new Map()
  };
  {
    hostRef.$onInstancePromise$ = new Promise(function (r) {
      return hostRef.$onInstanceResolve$ = r;
    });
  }
  {
    hostRef.$onReadyPromise$ = new Promise(function (r) {
      return hostRef.$onReadyResolve$ = r;
    });
    elm['s-p'] = [];
    elm['s-rc'] = [];
  }
  return hostRefs.set(elm, hostRef);
};

var consoleError = function consoleError(e, el) {
  return (0, console.error)(e, el);
};

var cmpModules = /*@__PURE__*/new Map();

var loadModule = function loadModule(cmpMeta, hostRef, hmrVersionId) {
  // loadModuleImport
  var exportName = cmpMeta.$tagName$.replace(/-/g, '_');
  var bundleId = cmpMeta.$lazyBundleId$;
  var module = cmpModules.get(bundleId);

  if (module) {
    return module[exportName];
  }

  return import(
  /* webpackInclude: /\.entry\.js$/ */

  /* webpackExclude: /\.system\.entry\.js$/ */

  /* webpackMode: "lazy" */
  "./".concat(bundleId, ".entry.js")).then(function (importedModule) {
    {
      cmpModules.set(bundleId, importedModule);
    }
    return importedModule[exportName];
  }, consoleError);
};

var styles = new Map();
var queueDomReads = [];
var queueDomWrites = [];

var queueTask = function queueTask(queue, write) {
  return function (cb) {
    queue.push(cb);

    if (!queuePending) {
      queuePending = true;

      if (write && plt.$flags$ & 4
      /* queueSync */
      ) {
        nextTick(flush);
      } else {
        plt.raf(flush);
      }
    }
  };
};

var consume = function consume(queue) {
  for (var i = 0; i < queue.length; i++) {
    try {
      queue[i](performance.now());
    } catch (e) {
      consoleError(e);
    }
  }

  queue.length = 0;
};

var flush = function flush() {
  // always force a bunch of medium callbacks to run, but still have
  // a throttle on how many can run in a certain time
  // DOM READS!!!
  consume(queueDomReads); // DOM WRITES!!!

  {
    consume(queueDomWrites);

    if (queuePending = queueDomReads.length > 0) {
      // still more to do yet, but we've run out of time
      // let's let this thing cool off and try again in the next tick
      plt.raf(flush);
    }
  }
};

var nextTick = /*@__PURE__*/function nextTick(cb) {
  return promiseResolve().then(cb);
};

var writeTask = /*@__PURE__*/queueTask(queueDomWrites, true);
export { bootstrapLazy as b, getElement as g, promiseResolve as p, registerInstance as r };